export enum UnsubscribeType {
    Undefined = 0,
    Event = 1,
    Campaign = 2
}
